import { Badge } from '@/components/ui/Badge';
import { cn } from '@/lib/utils';
import type { WsStatus } from '@/types/app';
import type { BadgeVariant } from '@/types/components.types';

const WS_CONFIG: Record<WsStatus, {
  variant: BadgeVariant; dot: string; label: string; pulse: boolean;
}> = {
  connected:    { variant: 'success', dot: 'bg-emerald-400', label: 'Live',        pulse: true  },
  connecting:   { variant: 'warning', dot: 'bg-amber-400',   label: 'Connecting…', pulse: true  },
  disconnected: { variant: 'default', dot: 'bg-zinc-500',    label: 'Offline',     pulse: false },
  error:        { variant: 'danger',  dot: 'bg-red-400',     label: 'Error',       pulse: false },
};

export function WsStatusDot({ status }: { status: WsStatus }) {
  const cfg = WS_CONFIG[status];
  return (
    <Badge variant={cfg.variant} className="gap-1.5">
      <span className={cn('w-1.5 h-1.5 rounded-full', cfg.dot, cfg.pulse && 'animate-pulse')} />
      {cfg.label}
    </Badge>
  );
}
